export default "__VITE_ASSET__304ea856__"